<template>
    <div>
        <div class="header-container">
            <h1 class="header-title">Terms & Conditions</h1>
        </div>
        <div class="content-container">
            <p><strong>Last Updated:</strong> 1st Jan 2025</p>
            <p>These Terms and Conditions ("Terms") govern your use of the e-invoice digital form services provided by
                <strong>Win2 Food Marketing Sdn. Bhd</strong>. ("we," "us," or "our"). By providing your information to us through our
                digital forms, you agree to comply with these Terms.</p>

            <section>
                <h3>1. ACCEPTANCE OF TERMS</h3>
                <p>By submitting your information through our e-invoice digital forms, you:</p>
                <ul>
                    <li>Confirm that the information provided is accurate and complete.</li>
                    <li>Agree to these Terms and our Privacy Policy.</li>
                    <li>Consent to the collection, use, and disclosure of your personal data as outlined in our Privacy
                        Policy.</li>
                </ul>
                <p>If you do not agree to these Terms, please do not use our services.</p>
            </section>

            <section>
                <h3>2. PURPOSE OF DATA COLLECTION</h3>
                <p>The information collected through our e-invoice digital forms is used to:</p>
                <ul>
                    <li>Comply with LHDN e-invoice requirements and other regulatory obligations.</li>
                    <li>Process and issue e-invoices for business transactions.</li>
                    <li>Maintain accurate financial records for reporting purposes.</li>
                </ul>
            </section>

            <section>
                <h3>3. USER RESPONSIBILITIES</h3>
                <p>When using our services, you agree to:</p>
                <ul>
                    <li><strong>Provide Accurate Information:</strong> Ensure that all information you provide is true,
                        accurate, and up to date.</li>
                    <li><strong>Update Information:</strong> Notify us promptly of any changes to the information
                        provided.</li>
                    <li><strong>Compliance with Laws:</strong> Use our services in compliance with all applicable laws
                        and regulations, including those related to tax and invoicing.</li>
                </ul>
            </section>

            <section>
                <h3>4. DATA PROTECTION</h3>
                <p>We handle your personal data in accordance with our Privacy Policy, which complies with the Personal
                    Data Protection Act (PDPA) 2010 of Malaysia.</p>
                <ul>
                    <li>Your data will be used solely for the purposes stated above.</li>
                    <li>We employ strict security measures to protect your data from unauthorized access or misuse.</li>
                </ul>
            </section>

            <section>
                <h3>5. DISCLAIMER OF LIABILITY</h3>
                <ul>
                    <li><strong>Accuracy of Information:</strong> While we strive to ensure accurate processing of your
                        e-invoice, you are responsible for the accuracy of the data submitted. We are not liable for
                        errors caused by incorrect or incomplete information provided by you.</li>
                    <li><strong>Service Interruptions:</strong> We are not responsible for any delays, interruptions, or
                        technical issues that may affect the availability of our digital forms or e-invoice services.
                    </li>
                    <li><strong>Third-Party Services:</strong> We are not liable for any issues arising from third-party
                        services used in the processing of e-invoices, such as governmental portals or software
                        providers.</li>
                </ul>
            </section>

            <section>
                <h3>6. TERMINATION OF SERVICE</h3>
                <p>We reserve the right to suspend or terminate your access to our services if:</p>
                <ul>
                    <li>You violate these Terms.</li>
                    <li>You provide false or misleading information.</li>
                    <li>Required by legal or regulatory authorities.</li>
                </ul>
            </section>

            <section>
                <h3>7. INTELLECTUAL PROPERTY</h3>
                <p>All content and materials related to our e-invoice digital forms, including text, graphics, and
                    software, are owned by or licensed to Win2 Food Marketing Sdn. Bhd. You may not reproduce,
                    distribute, or use any materials without our prior written consent.</p>
            </section>

            <section>
                <h3>8. GOVERNING LAW</h3>
                <p>These Terms are governed by and construed in accordance with the laws of Malaysia. Any disputes
                    arising under or related to these Terms shall be subject to the exclusive jurisdiction of the courts
                    in Malaysia.</p>
            </section>

            <section>
                <h3>9. CHANGES TO THESE TERMS</h3>
                <p>We reserve the right to modify these Terms at any time. Any updates will be posted on our website,
                    and where appropriate, communicated via email or other channels. Continued use of our services
                    constitutes your acceptance of the revised Terms.</p>
            </section>

            <section>
                <h3>10. CONTACT US</h3>
                <p>If you have any questions about this Terms and Conditions or our data practices, please contact us
                    at:</p>
                <ul>
                    <li style="margin-bottom: 0.5rem;"><strong>Email:</strong> <a
                            :href="`mailto:einvoice@win2food.com.my`">einvoice@win2food.com.my</a></li>
                    <li style="margin-bottom: 0.5rem;"><strong>Postal Address:</strong> No.6, Jalan Tahana, Kawasan
                        Perindustrian Tampoi, 81200 Johor Bahru, Johor, Malaysia.</li>
                    <li style="margin-bottom: 0.5rem;"><strong>Phone:</strong> +607-235 1103 (Hunting Line)</li>
                </ul>
                <p>By using our e-invoice digital form services, you acknowledge and agree to these Terms and
                    Conditions.</p>
            </section>
        </div>
    </div>
</template>


<script>
export default {
    name: "TermsAndConditions",
};
</script>

<style scoped>
.header-container {
    text-align: center;
    background-color: #3663e6;
    padding: 20px;
    max-width: 1200px;
    margin: 3rem auto 0 auto;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
}

.header-title {
    color: white;
}

.content-container {
    background: white;
    padding: 20px 50px;
    max-width: 1200px;
    margin: 0rem auto 3rem auto;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
}

h1,
h3 {
    margin: 1rem 0;
    color: black;
}

ul {
    margin: 0;
    padding: 0 0 0 20px;
}

li {
    margin-bottom: 1rem;
}

a {
    color: #007bff;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

p {
    text-align: justify;
}

@media (max-width: 575.99px) {
    .header-container {
        margin: 1.5rem 2rem 0 2rem;
    }

    .content-container {
        font-size: 0.875rem;
        margin: 0rem 2rem 1.5rem 2rem;
        padding: 20px 30px;
    }

    h1 {
        font-size: 2.5rem;
    }

    li {
        margin-bottom: 0.75rem;
    }

}
</style>